const vueComponents = {}



vueComponents.vueDescriptionTab = Vue.component('vue-description-tab', {
  props: ['productDescription', 'productHandle']
  ,data() {
    return ({isShogun: null})
  }
  ,mounted() {
    let _this = this;
    if (!this.productHandle) {
      return;
    }
    
    // $.get('/products/'+this.productHandle, function( data ) {

      if (_this.productDescription && _this.productDescription.indexOf('shogun') === -1) {
        _this.isShogun = false;
      } else {
        _this.isShogun = true;
        $.get('/products/'+this.productHandle+'?view=shogun-test', function( data ) {
          let ifrm = _this.$el;
          var doc = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
          doc.document.open();
          doc.document.write(data);
          doc.document.close();
          // $('body', doc.document).append($('<script src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.1.1/iframeResizer.contentWindow.min.js">')[0])
          iFrameResize({ log: false, checkOrigin: false }, '#product-description-iframe')
        });
    }
    if (affirm && typeof affirm.ui.refresh == 'function') {
      affirm.ui.refresh();
    }
  }
  ,delimiters: ['|', '|']
  ,template: `
    <iframe v-if="isShogun" id="product-description-iframe" class="product-description rte" data-product-description></iframe>
    <div v-else-if="productDescription" id="product-description" class="product-description rte" data-product-description v-html="productDescription"></div>
    <div v-else></div>
  `
})

vueComponents.vueProductWarning = Vue.component('vue-product-warning', {
  props: ['warning']
  ,delimiters: ['|', '|']
  ,template: `<div class="product-warning-container">
    <p class="product-warning" v-html="warning"></p>
  </div>`
})

vueComponents.vueSpecsTab = Vue.component('vue-specs-tab', {
  props: ['specs2', 'needsUpdating']
  ,delimiters: ['|', '|']
  ,template: `<vue-comparison-item
    v-bind:specs2="specs2"
    v-if="specs2"
    v-bind:needs-updating="needsUpdating"
  >
  </vue-comparison-item>`
})


vueComponents.vueAccessoriesTab = Vue.component('vue-accessories-tab', {
  props: ['inTheBox', 'supplementalProducts']
  ,delimiters: ['|', '|']
  ,template: `<div v-if="inTheBox" class="in-the-box-and-accessories">
    <div class="in-the-box-container">
    <h3 class="in-the-box-title"> In the Box </h3>
      <div class="in-the-box-category" v-for="(boxCategory, boxCategoryIndex) in inTheBox" :key="boxCategoryIndex">
        <h4>|boxCategory.title|</h4>
        <p v-for="(boxItem, boxItemIndex) in boxCategory.values" class="in-the-box-text" :key="boxItemIndex">| boxItem |</p>
      </div>
    </div>
    <vue-recommended-accessories v-bind:supplemental-products="supplementalProducts" v-bind:suppl-prod="supplProd"></vue-recommended-accessories>
  </div>`
})

vueComponents.vueRecommendedAccessories = Vue.component('vue-recommended-accessories', {
  props: ['accessories', 'inTheBox']
  ,delimiters: ['|', '|']
  ,template: `<div class="vue-recommended-accessories">
                <div class="collection-v1" v-if="inTheBox && typeof inTheBox == 'object' || accessories && typeof accessories == 'object' ">
                  <vue-recommended-accessory v-bind:in-the-box="inTheBox" v-for="(accessory, accessoryIndex) in accessories" :key="'supplemental'+accessoryIndex" v-bind:accessory="accessory"></vue-recommended-accessory>
                </div>
                <div class="collection-v1" v-else-if="inTheBox && typeof inTheBox == 'string'">
                {{inTheBox}}
                </div>
              </div>`
})

vueComponents.vueRecommendedAccessory = Vue.component('vue-recommended-accessory', {
  props: ['inTheBox', 'accessory'],
  data: function () {
    return {
      backupImage: bcSfFilterConfig.general.no_image_url
    }
  }
  ,computed: {
    accesoryHandle() {
      if (!this.accessory) {
        return ""
      } else {
        return `/products/${this.accessory.handle}`
      }
    },
    accessoryImage() {
      if (!this.accessory || !this.accessory.images.edges.length) {
        return ""
      } else {
        return this.accessory.images.edges[0].node.originalSrc
      }
    }
  }
  // ,delimiters: ['|', '|']
  ,filters: {
    thumbnail_img(image) {
      if (["_pico", "_icon", "_thumb", "_small", "_compact", "_medium", "_large", "_grande", "_original"].some(each => image.indexOf(each) > -1)) {
        return image;
      } else if (image.indexOf(".png.jpg") > -1) {
        return image.split(".png.jpg").join("_75x.png.jpg");
      } else if (image.indexOf(".png") > -1) {
        return image.split(".png").join("_75x.png");
      } else if (image.indexOf(".jpg") > -1) {
        return image.split(".jpg").join("_75x.jpg");
      } else {
        return image;
      }
    }
  }
  ,methods: {
    addOneToCart(variantId) {
      teradekAPI.addOneToCart(variantId)
    }
  }
  ,template: `<div class="collection-v1--grid-item">
                  <div class="collection-v1--grid-item-content">
                    <a :href="accesoryHandle">
                      <div class="collection-v1--grid-item-content--thumbnail">
                        <img v-if="accessoryImage" :src="accessoryImage">
                      </div>
                    </a>
                    <div class="collection-v1--grid-item-content--bottom">
                      <a v-if="accessory.id" :href="accesoryHandle">
                        <div class="collection-v1--grid-item-content--bottom--info">
                          <p class="collection-v1--product-title text-margin-top">{{accessory.title}}</p>
                          <p v-if="accessory.id && accessory.variants.edges.length" class="collection-v1--product-sku text-margin-top">{{accessory.variants.edges[0].node.sku}}</p>
                          <div class="collection-v1--grid-item-content--price-and-qty">
                          <p v-if="accessory.id && accessory.variants.edges.length && 
									accessory.variants.edges[0].node.compareAtPrice && 
									parseFloat(accessory.variants.edges[0].node.compareAtPrice).toFixed(2) != parseFloat(accessory.variants.edges[0].node.priceV2.amount).toFixed(2)" 
							class="collection-price collection-compare-at-price">\${{parseFloat(accessory.variants.edges[0].node.compareAtPrice).toFixed(2)}}</p>
                          <p v-if="accessory.id && accessory.variants.edges.length && accessory.variants.edges[0].node.priceV2" class="collection-price">\${{parseFloat(accessory.variants.edges[0].node.priceV2.amount).toFixed(2)}}</p>
                          <p v-if="inTheBox" class="collection-quantity">Qty: {{accessory.variants.edges[0].node.quantityPer}}</p>
                          </div>
                        </div>
                      </a>
                      <div v-else >
                        <div class="collection-v1--grid-item-content--bottom--info">
                          <p class="collection-v1--product-title text-margin-top">{{accessory.title}}</p>
                          <div class="collection-v1--grid-item-content--price-and-qty">
                            <p v-if="inTheBox" class="collection-quantity">Qty: {{accessory.variants.edges[0].node.quantityPer}}</p>
                          </div>
                        </div>
                      </div>
                      <div v-if="accessory.id && accessory.variants.edges.length" class="collection-v1--grid-item-content--bottom--actions">
                        <button v-if="inTheBox" class="add-to-cart-btn" :data-product-id="accessory.id" :data-variant-id="accessory.variants.edges[0].node.id" data-add-to-cart-btn @click="addOneToCart(accessory.variants.edges[0].node.id)">Add another</button>
                        <button v-else class="add-to-cart-btn" :data-product-id="accessory.id" :data-variant-id="accessory.variants.edges[0].node.id" data-add-to-cart-btn @click="addOneToCart(accessory.variants.edges[0].node.id)">Add to Cart</button>
                      </div>
                    </div>
                  </div>
                </div></a>`
})


vueComponents.vueComparisonItem = Vue.component('vue-comparison-item', {
props: ['specs2', 'needsUpdating']
,filters: {
  thumbnail_img(image) {
    if (["_pico", "_icon", "_thumb", "_small", "_compact", "_medium", "_large", "_grande", "_original"].some(each => image.indexOf(each) > -1)) {
      return image;
    } else if (image.indexOf(".png.jpg") > -1) {
      return image.split(".png.jpg").join("_150x.png.jpg");
    } else if (image.indexOf(".png") > -1) {
      return image.split(".png").join("_150x.png");
    } else if (image.indexOf(".jpg") > -1) {
      return image.split(".jpg").join("_150x.jpg");
    } else {
      return image;
    }
  }
}
,methods: {
  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }
}
,delimiters: ['|', '|']
,template: `<div class="column-container">
              <div class="tech-spec-list">
                <div class="tech-spec-category" v-for="(specCategory, index) in specs2" :key="'category'+index" :data-aspect-label="specCategory.aspectName">
                  <p class="cs-text-2 tech-spec-outer-label">|specCategory.aspectCategoryName|</p>
                  <div class="tech-spec" v-for="(spec, index) in specCategory.aspects" :key="'spec'+index" :data-aspect-label="spec.aspectName">
                    <p class="tech-spec-inner-label cs-text-1">| spec.aspectName |</p>
                    <a v-if="spec.data && validURL(spec.data)" class="tech-spec-text cs-text-1" :href="spec.data">|spec.data|</a>
                    <p v-else-if="spec.data" class="tech-spec-text cs-text-1" v-html="spec.data"></p>

                    <div v-for="(nestedSpec, nestedSpecIndex) in spec.aspects" :key="'nested'+nestedSpecIndex" class="tech-spec-aspect" :data-aspect-label="nestedSpec.aspectName">
                      <vue-comparison-item-spec
                        v-bind:expanded="nestedSpec.expanded"
                        v-bind:nestedSpec="nestedSpec"
                        v-bind:spec="spec"
                        v-bind:spec-category="specCategory"
                      ></vue-comparison-item-spec>
                    </div>

                  </div>
                </div>
              </div>
            </div>`
})

vueComponents.vueComparisonItemSpec = Vue.component('vue-comparison-item-spec', {
props: ['specs2', 'needsUpdating', 'nestedSpec', 'spec', 'specCategory']
,data: function () {
  return {
    expanded: false
  }
}
,filters: {
  thumbnail_img(image) {
    if (["_pico", "_icon", "_thumb", "_small", "_compact", "_medium", "_large", "_grande", "_original"].some(each => image.indexOf(each) > -1)) {
      return image;
    } else if (image.indexOf(".png.jpg") > -1) {
      return image.split(".png.jpg").join("_150x.png.jpg");
    } else if (image.indexOf(".png") > -1) {
      return image.split(".png").join("_150x.png");
    } else if (image.indexOf(".jpg") > -1) {
      return image.split(".jpg").join("_150x.jpg");
    } else {
      return image;
    }
  }
}
,delimiters: ['|', '|']
,template: `<div @click="expanded = !expanded" class="tech-spec-label-and-value">
              <label class="tech-spec-inner-label">| nestedSpec.aspectCategoryName | <span v-if="expanded === false">+</span></label>
              <div v-bind:class="{ 'tech-spec-preexpanded': true, 'tech-spec-expanded': expanded }">
                <p v-for="(nestedSpec2, nestedSpec2Index) in nestedSpec.aspects" :key="'nestedspec2'+nestedSpec2Index"><span class="tech-spec-inline-title"  v-if="nestedSpec2.aspectName !== nestedSpec.aspectCategoryName"> | nestedSpec2.aspectName | : </span>|nestedSpec2.data|</p>
              </div>
            </div>`
})

vueComponents.vueHeroWithTitle = Vue.component('vue-hero-with-title', {
props: ['heroText', 'heroImage']
,delimiters: ['|', '|']
,template: `<div class="camera-compare-banner">
  <div v-if="heroText" class="camera-compare-banner-text-and-image">
    <h1 class="camera-compare-banner-text">|heroText|</h1>
  </div>
  <img class="camera-compare-banner-image" :src="heroImage"/>
</div>`
})




vueComponents.compareTitle = Vue.component('compare-title', {
  template: `<div>
        <h4>Compare</h4>
      </div>`
})

vueComponents.compareItems = Vue.component('compare-items', {
  template: `<div class="compare-items">
        <slot>
        </slot>
      </div>`
})

vueComponents.compareItem = Vue.component('compare-item', {
  props: ['title', 'image', 'compareIndex']
  , delimiters: ['|', '|']
  , template: `<div class="compare-item">
        <div style="position: relative;">
          <i v-on:click="$emit('update:remove-compare-item', $event.target.value, compareIndex)" class="fas fa-window-close compare-close"></i>
        </div>
        <img class="compare-thumbnail" :src="image">
        <p class="compare-item-title">|title|</p>
      </div>`
})


vueComponents.modalCompare = Vue.component('modal-compare', {
  template: '#modal-template'
})

vueComponents.productRecommendation = Vue.component('product-recommendation', {
  props: ['cartItem', 'cartRecommended']
  , delimiters: ['|', '|']
  , filters: {
    thumbnail_img(image) {
      if (["_pico", "_icon", "_thumb", "_small", "_compact", "_medium", "_large", "_grande", "_original"].some(each => image.indexOf(each) > -1)) {
        return image;
      } else if (image.indexOf(".png.jpg") > -1) {
        return image.split(".png.jpg").join("_75x.png.jpg");
      } else if (image.indexOf(".png") > -1) {
        return image.split(".png").join("_75x.png");
      } else if (image.indexOf(".jpg") > -1) {
        return image.split(".jpg").join("_75x.jpg");
      } else {
        return image;
      }
    }
    , addQueryString(href) {
      if (href.indexOf("?") === -1) {
        return href + "?new-item=" + collectionApp.cartItem.sku
      } else {
        return href + "&new-item=" + collectionApp.cartItem.sku
      }
    }
    , addedToCart(title) {
      return title + `<span style="font-weight: normal"> has been added to cart!</span>`
    }
  }
  , template: `<div class="product-recommendation">
        <div class="product-recommendation-top">
          <h4 class="product-recommendation-header">|cartItem.title|</h4>
        </div>
        <div class="product-recommendation-main">
          <img class="product-recommendation-thumbnail-large-screen" :src="cartItem.image | thumbnail_img"></img>
          <div>
            <h4 class="product-recommendation-header-large">|cartItem.title|</h4>
            <p class="product-recommendation-text">Added to cart!</p>
            <p class="product-recommendation-text">We recommend checking out these accessories.</p>
            <div class="product-recommendation-items" v-if="cartRecommended">
              <a class="product-recommendation-item" v-for="requirement in cartRecommended.requires" :href="requirement.href | addQueryString">|requirement.message| x |requirement.quantity|</a>
            </div>
          </div>
        </div>
      </div>`
})


vueComponents.filterCollectionBreadcrumbs = Vue.component('filter-collection-breadcrumbs', {
  props: ['collectionName', 'collectionBreadcrumb']
  , delimiters: ['|', '|']
  , template: `<div class="filter-collection-breadcrumbs">
        <a class="breadcrumb-link" :href="collectionBreadcrumb"><h3 class="collection-name">Learn about |collectionName|</h3></a> <span style="margin: 0 7px;">></span> <a class="breadcrumb-link"><h3 class="collection-name">|collectionName|</h3></a>
      </div>`
})

vueComponents.cartModal = Vue.component('cart-modal', {
  props: ['isSidecartShowing', 'cart', 'cartItems', 'updatedIndex', 'errorMessage'],
  data() {
    return {
      modalStyle: "display: none !important;"
    }
  },
  computed: {
    originalTotalPrice() {
      if (!this.cart || !this.cart.original_total_price) {
        return ""
      } else {
        return (this.cart.original_total_price / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });
      }
    },
    cartMessage() {
      if(!(this.cartItems)){return false;}
      let messages = this.cartItems.find(each => each.product.tags.indexOf("shipping_unknown") > -1 )
      if (messages) {
        return true
      } else {
        return false
      }
    }
  },
  watch:{
    "cart.original_total_price": function(newCartPrice) {
        if( newCartPrice >= 25000 ){
            $('#affirm-cart-message').attr('data-amount',newCartPrice).show();
            if (affirm && typeof affirm.ui.refresh == 'function' ) {
                affirm.ui.refresh();
              }
        }                          
        else{
            $('#affirm-cart-message').hide();
        }
     }
  },
  filters: {
    money: function(value) {
      return (value / 100).toLocaleString("en-US", { style: "currency", currency: "USD" }).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted() {
    // this.modalStyle = "display: inline-block !important;";
  },
  // delimiters: ['|', '|'],
  template: `<div id="sidecart-modal" v-bind:class="{ 'sidecart-modal-showing': isSidecartShowing, 'sidecart-modal-hidden': !isSidecartShowing }">
                <div class="sidecart-modal--backdrop" @click="$emit('hide-sidecart')">
                </div>
                <form class="cart-form" v-bind:class="{ 'cart-form-showing': isSidecartShowing, 'cart-form-hidden': !isSidecartShowing }">
                  <div class="hide-cart-button">
                    <i class="fas fa-times" @click="$emit('hide-sidecart')"></i>
                  </div>
                  <h2>Cart</h2>
                  <div class="sidecart-message" v-if="cartMessage">
                    <p>Some item(s) in your cart having processing delays which will affect your order:</p>
                    <p>The shipping method you choose for this order will only be used AFTER your order has completed processing.</p>
                    <p>All items in your cart will be bundled in the same shipment. If you need some items sooner, please separate the orders.</p>
                  </div>
                  <cart-products
                    v-bind:cart-items="cartItems"
                    v-bind:error-message="errorMessage"
                    @update-cart-item="(...args) => $emit('update-cart-item', ...args)"
                  />
                  <div class="sidecart-footer">
                    <p v-if="errorMessage">{{errorMessage}}</p>
                    <div class="sidecart-footer--actions">
                      <p>CART SUBTOTAL: {{originalTotalPrice}} <span class="currency-text">USD only</span></p>
                      <p id="affirm-cart-message" class="affirm-as-low-as" :data-amount="cart.original_total_price" data-page-type="cart"></p>
                    </div>
                                        
                    <a href="/cart">
                      <div>
                        <p class="sidecart-footer--action--green">VIEW CART</p>
                      </div>
                    </a>
                    <!--div class="sidecart-footer--actions">
                      <a href="/checkout">
                        <p class="sidecart-footer--action--green">CHECKOUT NOW</p>
                      </a>
                    </div-->
                  </div>
                </form>
              </div>`
})


vueComponents.cartProducts = Vue.component('cart-products', {
  props: ['cartItems', 'errorMessage'],
  filters: {
    money: function(value) {
      return (value / 100).toLocaleString("en-US", { style: "currency", currency: "USD" })
    }
  },
  updated: function() {
  	//console.log("this.cartItems[0].properties", this.cartItems[0].properties)
  },
  template: `<div class="sidecart-products">
  <div class="sidecart-product" v-for="(cartItem, cartItemIndex) in cartItems" :data-cartitem-id="cartItem.id" :key="cartItem.id">
    <div class="sidecart-product--main">
	  <div class="sidecart-products--thumbnail">
		<a :href="cartItem.url">
        <img v-if="cartItem.image" :src="cartItem.image">
        <img v-else src="http://cdn.shopify.com/s/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_100x.gif">
		</a>
      </div>
      <div class="sidecart-products--content">
        <p class="sidecart-products--content--title" v-html="cartItem.product.title"></p>
        <p class="sidecart-products--content--sku" v-text="cartItem.sku"></p>

        <div class="sidecart-products--content--options">
          <p v-for="option in cartItem.options" v-if="option.name !== 'Title'">{{option.name}}: {{option.value}}</p>
        </div>
        <div class="sidecart-products--content--right">
          <cart-quantity
            v-bind:cart-item="cartItem"
            @update-cart-item="(...args) => $emit('update-cart-item', ...args)"
            v-bind:cart-key="cartItem.key"
            v-bind:quantity="cartItem.quantity"
            v-bind:id="cartItem.id"
          />
          <div class="sidecart-item-prices">
            <p v-if="cartItem.compare_at_price && cartItem.compare_at_price != cartItem.price" 
						class="sidecart-item-compare-price">{{cartItem.compare_at_price | money}}</p>
            <p class="sidecart-item-price" 
				v-bind:class="{ 'sidecart-item-new-price': cartItem.compare_at_price && cartItem.compare_at_price != cartItem.price, 'sidecart-item-no-compare': !cartItem.compare_at_price }">
				{{cartItem.price | money}}
			</p>
          </div>
          <button class="sidecart-products--content--remove-cart-item" @click="$emit('update-cart-item', 0, cartItem.key)">x</button>
        </div>
      </div>
	</div>
  	<p class="sidecart-products--message" v-if="cartItem.product.tags.indexOf('shipping_unknown') > -1">This product has a shipping delay</p>
  	<p class="sidecart-products--message" v-if="cartItem.properties && cartItem.properties.Preorder">
<span>This item is available for PRE-ORDER.</span><br>
<span style="font-size:12px;"> 
Orders with pre-ordered items will ship when all items are available. Please check out for regular items separately if immediate shipping is desired.
</span>
</p>
  </div>
  <p class="sidecart-products--error" v-if="errorMessage">{{errorMessage}}</p>
</div>`
})

vueComponents.cartQuantity = Vue.component('cart-quantity', {
  props: ['cartItem', 'id', 'quantity', 'cartKey'],
  data() {
    return {
      forceInput: false,
      disabled: false,
      changedQuantity: false,
    }
  },
  methods: {
    handleUpdateCartItem(event) {
      // this.disabled = true;
      if (event.target.value === "10+") {
        this.forceInput = true;
        // this.$emit('update-quantity', 10, this.cartKey, this.id)
        // this.quantity = 10;
        this.$emit('update-cart-item', 10, this.cartKey, this.id)
      } else if (event.target.value === "10") {
        this.forceInput = true;
        this.$emit('update-cart-item', event.target.value, this.cartKey, this.id)
      } else if (event.target.value === "") {
        return;
      } else {
        this.$emit('update-cart-item', event.target.value, this.cartKey, this.id)
      }
    },
    handleUpdateCartFromInput(event) {
      this.$emit('update-cart-item', parseInt(event.target.value), this.cartKey, this.id)
    }
  },
  watch: {
    quantity(currentQuantity, prevQuantity) {
      let _this = this;
      if (_this.disabled) {
        return;
      }
      if (currentQuantity === prevQuantity) {
        return;
      } else {
        // this.disabled = true;
        if (_this.quantity === "10+") {
          _this.forceInput = true
          _this.quantity = "10"
          _this.$emit('update-cart-item', 10, _this.cartKey, _this.id)
        } else if (parseInt(_this.quantity) >= 10) {
          _this.forceInput = true
          // _this.$emit('update-cart-item', _this.quantity, _this.cartKey, _this.id)
        } else if (_this.quantity === "") {
          return;
        } else {
          if (!_this.showInputInstead) {
            _this.$emit('update-cart-item', _this.quantity, _this.cartKey, _this.id)
          }
        }
      }
    }
  },
  mounted() {
    let _this = this;
    if (parseInt(_this.quantity) >= 10) {
      this.forceInput = true;
    }
    console.log("this.cartItem", this.cartItem);
  },
  computed: {
    updateKey() {
      return "updates_"+this.cartKey
    },
    showInputInstead() {
      if (this.forceInput || parseInt(this.quantity) > 9) {
        return true;
      } else {
        return false;
      }
    }
  },
  template: `<div class="">
                <div v-if="showInputInstead" class="sidecart-product--quantity-container">
                  <label class="sidecart-product--quantity-container-label" for="ten-plus-quantity" aria-label="ten-or-less-quantity">Quantity</label>
                  <input type="number" v-model.number="quantity" @keydown.enter.prevent="handleUpdateCartFromInput" @change="handleUpdateCartFromInput" name="ten-plus-quantity" class="quantity-input"/>
                  <button @click="handleUpdateCartFromInput()" v-if="changedQuantity" class="change-quantity-button" v-bind:class="{ 'change-quantity-icon-active': changedQuantity }">
                    <p>Change</p>
                  </button>
                </div>
                <div v-else class="form-field-select-wrapper">
                  <select name="ten-or-less-quantity" v-model="quantity" class="form-field-input form-field-select form-field-filled quantity-select" aria-label="ten-or-less-quantity">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option title="Ten or more" value="10+">10+</option>
                  </select>
                  <label for="ten-or-less-quantity" class="form-field-title">
                    Quantity
                  </label>
                  <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6">
                    <g fill="currentColor" fill-rule="evenodd">
                      <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"></polygon>
                      <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"></polygon>
                    </g>
                  </svg>
                </div>
              <div class="form-field form-field--qty-input hidden">
                <input class="form-field-input form-field-number form-field-filled" :value="quantity" name="updates[]" :id="updateKey" type="text" pattern="\d*" tabindex="-1" aria-label="Quantity">
                <label class="form-field-title" :for="updateKey">
                  Quantity
                </label>
              </div>
            </div>`
})

vueComponents.productTemplate = Vue.component('product-template', {
  props: ['product', 'selectedVariant', 'validVariants']
  ,data () {
    return {
      tabSelected: 0,
      quantity: 1,
      changeQuantityToInput: false,
      imageIndexSelected: 0,
      needsUpdating: 0,
      inTheBoxSkus: [],
      bundles: [],
      supplProd: [],
      selectedVariantId: this.selectedVariant && this.selectedVariant.id
    }
  }
  ,computed: {
    selectedImage() {
      if (!this.product || this.product.images.edges.length === 0) return null;
      return this.product.images.edges[this.imageIndexSelected].node.originalSrc
    },
    productImages() {
        if (!this.product && this.selectedVariant) return [];
        let variantImages = this.product.images.edges.filter(img => { 
          return !img.node.altText || 
				(img.node.altText && img.node.altText.includes(this.selectedVariant.sku)) || 
            	img.node.id == this.selectedVariant.image.id });
        return variantImages.map(img => { 
            img.node.src = img.node.originalSrc.replace(/\.png\?/, '_800x.png?' ).replace(/\.jpg\?/, '_800x.jpg?'); 
            return img;
        })
    },
    variantTitles() {
      if (!this.product) return null;
      return this.product.variants.edges.map(({node}) => node.title)
    },
    productDescription() {
      if (!this.product) return null;
      let content =  (this.selectedVariant.description) ? this.selectedVariant.description.value : this.product.descriptionHtml;
      /*var decoded = $('<textarea/>').html(content).text();
      let newContent = decoded.replace(/<style([\S\s]*?)>([\S\s]*?)<\/style>/ig,'');*/
      return content;
      //return newContent;
    },
    productHeader1() {
        if (!this.product) return null;
        if (this.selectedVariant && this.selectedVariant.header1) {
          return this.selectedVariant.header1.value;
        }
        if (this.product.header1) {
          return this.product.header1.value;  
        }
        return null;
    },
    keyBullets() {
      if (!this.product) return null;
      if (this.selectedVariant && this.selectedVariant.keyBullets){
        return this.selectedVariant.keyBullets.value;
      }
      if (this.product.keyBullets) {
        return this.product.keyBullets.value;
      }
      return null;
    },        
    selectedOptions() {
      if (!this.selectedVariant) return null;
      return this.selectedVariant.title.split(' / ') 
    },
    supplementalProducts() {
      if (this.timeToLoadVariants === false || !this.product) {return null};
      let skus = this.product.variants.edges.reduce((acc, variant) => {
        if (!variant.node.suppl_prod) return acc;
        let skus = variant.node.suppl_prod.value.split(',').map(sku => sku.trim()).filter(sku => acc.indexOf(sku) === -1);
        acc.push(...skus);
        return acc;
      }, []);
      let supplementalProducts = [];
      skus.forEach(sku => {
        Object.keys(allProductInfo).forEach(productId => {
          let foundVariant = allProductInfo[productId].variants.edges.find(each => {
            return each.node.sku === sku
          });
          if (foundVariant) {
            foundVariant.node.product = {};
            foundVariant.node.product.title = allProductInfo[productId].title
            foundVariant.node.product.images = allProductInfo[productId].images
            supplementalProducts.push(foundVariant.node);
          }
        })
      })
      return supplementalProducts
    },
    inTheBox() {
      if (!this.selectedVariant || !this.selectedVariant.inTheBox) return null;
      var inTheBox1 = $('<textarea/>').html(this.selectedVariant.inTheBox.value).text();
      let description = inTheBox1.match(/\[DESC\](.*?)\[DESC\]/g);
      let inTheBox2 = inTheBox1.replace(/\[DESC\](.*?)\[DESC\]/g, '');
      let collapsed = inTheBox2.match(/\[COLLAPSE\](.*?)\[COLLAPSE\]/g)
      let inTheBox3 = inTheBox2.replace(/\[COLLAPSE\](.*?)\[COLLAPSE\]/g,'');
      let collapsedLists = collapsed.map(each => {
        let textWithoutTags = each.length > 0 ? each.slice(10).slice(0, -10) : null ;
        let splitTextWithoutTags = textWithoutTags.split('<br />');
        let title = splitTextWithoutTags[0]
        let values = splitTextWithoutTags.slice(1)
        return ({title, values})
      })
      let parseBreaks = inTheBox3.replace(/\[LIST\]/g, '').split('<br />')
      let finalInTheBox = [...collapsedLists, {title: "Misc", values: parseBreaks}]
      return finalInTheBox
    },
    specs2: {
      get: function () {
        if (!this.selectedVariant || !this.selectedVariant.specs2) return null;

        let jsonSpecs = JSON.parse(this.selectedVariant.specs2.value.slice());
        let specs = jsonSpecs.reduce((acc, currVal) => {
          let aspects = currVal.aspects.filter(aspect => {
            return aspect.data !== "N/A" && aspect.aspectName !== "sku" && aspect.aspectName !== "productId"
          }).map(aspect => {
          if (!aspect.aspects) {
          } else {
            let nestedAspects = aspect.aspects.map(aspect => {
              let filteredAspects = aspect.aspects.filter(nestedAspect => {
                return nestedAspect.data !== "N/A"
              }).map(aspect => {
                let aspectName = aspect.aspectName ? (aspect.aspectName) : aspect.name
                // let aspectName = aspect.aspectName ? this.camelToTitleCase(aspect.aspectName) : aspect.name
                aspect.aspectName = aspectName
                return aspect
              })
              
              aspect.aspects = filteredAspects;
              return aspect;
            }).filter(aspect => {
              
              return aspect.aspects.length !== 0 && aspect.aspectCategoryName !== "productId"
            }).map(each => {
              //each.expanded = false;
              this.$set(each, 'expanded', false)
              each.aspectCategoryName = (each.aspectCategoryName)
              // each.aspectCategoryName = this.camelToTitleCase(each.aspectCategoryName)
              return each
            })
            aspect.aspects = nestedAspects
          }
          let aspectName = aspect.aspectName ? (aspect.aspectName) : aspect.name
          // let aspectName = aspect.aspectName ? this.camelToTitleCase(aspect.aspectName) : aspect.name
          //let aspects = currVal.aspects.filter(aspect => aspect.levelOfDetail === 20 && aspect.data !== "N/A").map(aspect => {
            aspect.aspectName = aspectName;
            return aspect
          })
          currVal.aspects = aspects;
          if (aspects.length > 0) {
            acc.push(currVal)
          }
          return acc;
        }, []).map(aspect => {
          aspect.aspectCategoryName = (aspect.aspectCategoryName)
          // aspect.aspectCategoryName = this.camelToTitleCase(aspect.aspectCategoryName)
          return aspect;
        });
        return specs;
      },
      set: function(newValue) {
        this.needsUpdating = ++this.needsUpdating
        return newValue
      }
    }
  },
  watch: {
    selectedVariant: function (val) {
      this.changeUrl();
    },
  },
  filters: {
    thumbnail_img(image) {
      if (["_pico", "_icon", "_thumb", "_small", "_compact", "_medium", "_large", "_grande", "_original"].some(each => image.indexOf(each) > -1)) {
        return image;
      } else if (image.indexOf(".png.jpg") > -1) {
        return image.split(".png.jpg").join("_150X.png.jpg");
      } else if (image.indexOf(".png") > -1) {
        return image.split(".png").join("_150X.png");
      } else if (image.indexOf(".jpg") > -1) {
        return image.split(".jpg").join("_150X.jpg");
      } else {
        return image;
      }
    }
  }
  ,mounted() {
    let _this = this;
    _this.loadInTheBox(this.product.variants.edges[0].node);
    _this.loadAccessories(this.product);
    _this.loadBundles(this.product);
    $('.vue-product--go-to-top').click(() => {
      if ($('.vue-modal--modal-container .vue-product--go-to-top').length) {
        $('.vue-modal--modal-container')[0].scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    })
    $('.tech-spec[data-aspect-label="Firmware"] a').each((k,v) => {
      if (v.href) {
        $(v).text("View Firmware")
      }
    })
    let targetElement = document.querySelector('.vue-modal--modal-container')
    // bodyScrollLock.disableBodyScroll(targetElement);

    function visibleElement(){
      let isModal = $('.vue-modal--modal-container').length
      let windowPos = isModal ? $('.vue-modal--modal-container').scrollTop() : $(window).scrollTop() ;
      let windowHeight = isModal ? $('.vue-modal--modal-container').height() : $(window).height() ;
      if ($('.vue-modal--modal-container').width() > 0 || $(window).width() > 0) {
        $(".animate", $('#product-description-iframe').contents()).each(function() {
          var reqPos = windowPos+(windowHeight-75);
          var btnTopOffset = $( this ).offset().top-100;
          if (btnTopOffset < reqPos) { $( this ).addClass('begin-animate'); } else { $( this ).removeClass('begin-animate'); }
        });
        $(".animate").each(function() {
          var reqPos = windowPos+(windowHeight-75);
          var btnTopOffset = $( this ).offset().top-100;
          if (btnTopOffset < reqPos) { $( this ).addClass('begin-animate'); } else { $( this ).removeClass('begin-animate'); }
        });
        $(".animate-bg", $('#product-description-iframe').contents()).each(function() {
          var reqPos = windowPos+(windowHeight-75);
          var btnTopOffset = $( this ).offset().top-100;
          if (btnTopOffset < reqPos) { $( this ).addClass('begin-animate-bg'); } else { $( this ).removeClass('begin-animate-bg'); }
        });
        $(".animate-bg").each(function() {
          var reqPos = windowPos+(windowHeight-75);
          var btnTopOffset = $( this ).offset().top-100;
          if (btnTopOffset < reqPos) { $( this ).addClass('begin-animate-bg'); } else { $( this ).removeClass('begin-animate-bg'); }
        });
      }
    }
  
    $(document).unbind("scroll").bind('scroll', function (event) {
      visibleElement();
    });
    // document.addEventListener('scroll', function (event) {
    //   visibleElement();
    // }, true /*Capture event*/);

    $('.vue-modal--modal-container').unbind("scroll").bind('scroll', function() {
      visibleElement();
    });
    visibleElement();
    _this.changeUrl();
  }
  ,methods: {
    loadBundles(product) {
      let _this = this;
      let accessories = product.variants.edges[0].node.bundles && product.variants.edges[0].node.bundles.value;
      if (!accessories) {
        return;
      }
      let query = storefrontQueries.getAccessories(accessories);
      return teradekAPI.getGraphQLQuery(query)
      .then(response => {
        let accessories = Object.keys(response.data).map((each, eachIndex) => response.data[each]).filter(each => each).map(each => {
          let decodedProductId = atob(each.id).replace('gid://shopify/Product/', '');
          each.id = decodedProductId;
          return each;
        })
        accessories.forEach(accessory => {
          accessory.variants.edges.forEach(({node}) => {
            let decodedVariantId = atob(node.id).replace('gid://shopify/ProductVariant/', '');
            node.id = decodedVariantId;
          })
        })
        // let products = response.data.products;
        _this.bundles = accessories;
      })
      .catch(err => {
       
        console.log(err)
      });
    },
    parseInTheBox(components) {
      var regex = /^\(\d+\)\s/;
      return components.map((each, eachIndex) => {
        let hasQuantity = regex.test(each);
        let groups = regex.exec(each);
        if (hasQuantity) {
          let unformattedQuantity = groups[0];
          let sku = each.split(') ')[1]
          let quantity = unformattedQuantity.replace('(', '').split(') ')[0]
          return ({
            sku: sku,
            quantity: quantity
          })
        } else {
          return ({
            sku: each,
            quantity: 1
          })
        }
      })
    },
    loadInTheBox(variant) {
      let _this = this;
      //product.variants.edges[0].node;
      let accessories = variant.inTheBoxSkus && variant.inTheBoxSkus.value;
      accessories = accessories && accessories.split(', ').join(',').split(',')
      if (!accessories) {
        return;
      }
      let quantityPerSku = this.parseInTheBox(accessories);
      let accessoriesString = quantityPerSku.map(each => each.sku).join(',');
      let query = storefrontQueries.getAccessories(accessoriesString);
      return teradekAPI.getGraphQLQuery(query)
        .then(response => {
            let newAccessories = Object.keys(response.data).map((each) => response.data[each]).map((each, eachIndex) => {
            if (each && each.id) {
                let decodedProductId = atob(each.id).replace('gid://shopify/Product/', '');
                each.id = decodedProductId;
            } else {
                let missingAccessory = quantityPerSku[eachIndex]
                each = {
                id: null,
                title: missingAccessory.sku,
                handle: missingAccessory.sku,
                tags: [],
                images: {edges: []},
                variants: {edges: [
                    {node: {quantityPer: missingAccessory.quantity}}
                ]},
                }
            }
            return each;
            })
            newAccessories.forEach(accessory => {
                if (accessory && accessory.id && accessory.variants.edges.length) {
                    accessory.variants.edges.forEach(({node}) => {
                    let quantityPer = quantityPerSku.find(each => each.sku.toLowerCase() === accessory.handle.toLowerCase());
                    let decodedVariantId = atob(node.id).replace('gid://shopify/ProductVariant/', '');
                    node.id = decodedVariantId;
                    if (quantityPer && quantityPer.quantity) {
                        node.quantityPer = parseInt(quantityPer.quantity);
                    } else {
                        node.quantityPer = "unknown";
                    }
                    });
                }
            });
        
            return newAccessories;
        })
      .catch(err => {
        
        console.log(err)
      });
    },
    loadAccessories(product) {
      let _this = this;
      let accessories = product.variants.edges[0].node.suppl_prod && product.variants.edges[0].node.suppl_prod.value;
      console.log('HERE! accessories', accessories);
      if (!accessories) {
        return;
      }
      let query = storefrontQueries.getAccessories(accessories);
      return teradekAPI.getGraphQLQuery(query)
      .then(response => {
        console.log('response', response.data);
        let accessories = Object.keys(response.data).map((each, eachIndex) => response.data[each]).filter(each => each).map(each => {
          let decodedProductId = atob(each.id).replace('gid://shopify/Product/', '');
          each.id = decodedProductId;
          return each;
        })
        accessories.forEach(accessory => {
          accessory.variants.edges.forEach(({node}) => {
            let decodedVariantId = atob(node.id).replace('gid://shopify/ProductVariant/', '');
            node.id = decodedVariantId;
          })
        })
        // let products = response.data.products;
        _this.supplProd = accessories;
      })
      .catch(err => {
        console.log(err)
      });
    },
    changeQuantity(deltaChange) {
      let newQuantity = parseInt(this.quantity) + parseInt(deltaChange);
      if (newQuantity < 0) {
        this.quantity = 0;
      } else {
        this.quantity = newQuantity;
      }
    },
    handleChangeOption(optionIndex, selectValue) {
      let newVariantTitleBeforeChecks = [...this.selectedOptions.slice(0,optionIndex), selectValue, ...this.selectedOptions.slice(optionIndex+1)].join(' / ');
      
      if (!this.variantTitles.includes(newVariantTitleBeforeChecks)) {
        let option1Value = optionIndex === 0 ? selectValue.toLowerCase() : this.selectedOptions[0] ? this.selectedOptions[0].toLowerCase() : null;
        let option2Value = optionIndex === 1 ? selectValue.toLowerCase() : this.selectedOptions[1] ? this.selectedOptions[1].toLowerCase() : null;
        let option3Value = optionIndex === 2 ? selectValue.toLowerCase() : this.selectedOptions[2] ? this.selectedOptions[2].toLowerCase() : null;


        let allVariants = this.product.variants.edges.map(({node}) => {
          let variant = node;
          let count = 0;
          if (variant.selectedOptions[0] && option1Value && option1Value === variant.selectedOptions[0].value.toLowerCase()) {
            count++
          }
          if (variant.selectedOptions[1] && option2Value && option2Value === variant.selectedOptions[1].value.toLowerCase()) {
            count++
          }
          if (variant.selectedOptions[2] && option3Value && option3Value === variant.selectedOptions[2].value.toLowerCase()) {
            count++
          }
          return ({
            sku: variant.sku,
            id: variant.id,
            count,
            option1: variant.selectedOptions[0],
            option2: variant.selectedOptions[1],
            option3: variant.selectedOptions[2]
          })
        });

        let sortedVariants = allVariants.sort((a,b) => {
          return b.count-a.count
        })
        .filter(each => each.option1.value.toLowerCase() === option1Value.toLowerCase())
        let finalVariants = [];
        if (sortedVariants[0].option1) {
          finalVariants.push(sortedVariants[0].option1.value)
        }
        if (sortedVariants[0].option2) {
          finalVariants.push(sortedVariants[0].option2.value)
        }
        if (sortedVariants[0].option3) {
          finalVariants.push(sortedVariants[0].option3.value)
        }
        let finalVariantTitle = finalVariants.join(' / ');
        //let finalSelectedVariant = this.product.variants.find(variant => variant.title === finalVariantTitle);
        this.selectedVariantTitle = finalVariantTitle;
        
        let newVariant = this.product.variants.edges.find(({node}) => node.title === finalVariantTitle);
        this.selectedVariant = newVariant.node;
        this.selectedVariantId = newVariant.node.id;
      } else {
        let newVariant = this.product.variants.edges.find(({node}) => node.title === newVariantTitleBeforeChecks);
        this.selectedVariant = newVariant.node;
        this.selectedVariantId = newVariant.node.id;
      }
    },
    camelToTitleCase(aspectCategoryName) {
      let addSpaces = aspectCategoryName.replace( /([A-Z])/g, " $1" );
      let title = addSpaces.charAt(0).toUpperCase() + addSpaces.slice(1); // capitalize the first letter - as an example.
      return title
    },
    addToCart(a, b, isPreorder) {
      let _this = this;
      var quantity = !!this.quantity ? parseInt(this.quantity) : "1";
      let formData = [
        {name: "form_type", value: "product"}
        ,{name: "utf8", value: "✓"}
        ,{name: "id", value: this.selectedVariant.id}
        ,{name: "quantity", value: quantity}
      ];
      let formData2 = {
        id: this.selectedVariant.id,
        quantity: quantity,
        utf8: "✓",
      };
      if (isPreorder) {
        formData2.properties = {
          'Preorder': true
        };
      }
      console.log("formData2", formData2);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {items: [formData2]},
        dataType: 'json'
      }).done(function (response) {
        let itemResponse = response;
        $.ajax({
          type: 'GET',
          url: '/cart?view=cart-info.json',
          success: function (resp) {
            try {
              let cart = JSON.parse(resp);
              vueCartApp.updateSidecart(cart);
              // teradekAPI.updateSidecart(response)
              $('[data-header-cart-count]').attr('data-header-cart-count', cart.item_count).toggleClass('visible', cart.item_count > 0);
            } catch(err) {
            
            }
          }
        });
      }).fail(function (response) {
        try {
          let responseText = JSON.parse(response.responseText)
          if (responseText && responseText.description && responseText.description.indexOf("already sold out") === -1) {
            Sentry.addBreadcrumb({
              category: 'cart',
              message: 'Variant ID: ' + variantId,
              level: Sentry.Severity.Info
            });
           
            alert(responseText.description)
          } else if (responseText && responseText.description) {
            alert(responseText.description)
          }
        } catch(err) {
          
        }
      });
    },
    changeAccordion(index) {
      this.tabSelected = parseInt(index)
    },
    changeUrl() {
      let url
      if (!this.product && !this.selectedVariant) {
        return;
      } else if (!this.selectedVariant) {
        if (window.location.href.indexOf('/collections') > -1) {
          url = `${window.location.origin}${window.location.pathname}?product_id=${this.product.id}`
          window.history.pushState({path:url},'',url);
        }
      } else {
        if (window.location.href.indexOf('/collections') > -1) {
          url = `${window.location.origin}${window.location.pathname}?product_id=${this.product.id}&variant_id=${this.selectedVariant.id}&product_handle=${this.product.handle}`
          window.history.pushState({path:url},'',url);
        }
      }
    }
  }
  ,asyncComputed: {
    inTheBoxAsync () {
        if (!this.selectedVariant){ return null; }
        return this.loadInTheBox(this.selectedVariant);
    }
  }  
  ,delimiters: ['|', '|']
  ,template: `<div class="vue-product--container">
                <button data-close-modal class="close-modal-button">
                  <i data-close-modal class="fas fa-times"></i>
                </button>
                <h1 class="vue-product--title vue-product--title-mobile letter-spacing-2">|product.title|</h1>
                <p class="vue-product--sku vue-product--sku-mobile">|selectedVariant.sku|</p>
                <div class="vue-product--container--images-and-key-bullets-and-options">
                  <div class="vue-product--container--images">
                    <image-gallery v-bind:productImages="productImages"/>
                  </div>
                  <div class="vue-product--container--key-bullets-and-options">
                    <div class="vue-product--container--key-bullets-info">
                      <h1 class="vue-product--title vue-product--title-web letter-spacing-2">|product.title|</h1>
                      <p class="vue-product--sku vue-product--sku-web">|selectedVariant.sku|</p>
                      <p v-if="productHeader1" class="vue-product--header1" v-html="productHeader1">|</p>
                      <p v-if="product.header2" class="vue-product--header2" v-html="product.header2.value">|</p>
                      <div v-if="product.tags.includes('B-Stock')" class="vue-product--header2">
                      This "B-Stock" item does not meet our high quality-control standards and/or will show slight signs of use. 
					 We offer a 14-day return policy on all B-stock monitors, but they have no additional warranty and are sold as-is.
                      </div>
                      <div style="text-align: left;" class="vue-product--container--key-bullets">
                        <div v-if="keyBullets" v-html="keyBullets"></div>
                      </div>
                    </div>
                    <product-options
                      @add-to-cart="addToCart"
                      @change-quantity="changeQuantity"
                      v-bind:variant-titles="variantTitles"
                      v-bind:selected-options="selectedOptions"
                      v-bind:selected-variant="selectedVariant"
                      v-on:change-option="handleChangeOption(...arguments)"
                      v-bind:product="product"
                      v-bind:change-quantity-to-input="changeQuantityToInput"
                      v-bind:quantity="quantity"
                      v-bind:valid-variants="validVariants"
                    >
                    </product-options>
                  </div>
                </div>
                <div class="vue-product--tabs" v-if="productDescription || specs2 || inTheBoxSkus.length || supplProd.length || bundles.length">
                  <div v-if="productDescription" class="vue-product--tab" v-bind:class="{ 'vue-product--tab-selected': tabSelected === 0}" @click="tabSelected = 0">
                    <p>DESCRIPTION</p>
                  </div>
                  <div v-if="specs2" class="vue-product--tab" v-bind:class="{ 'vue-product--tab-selected': tabSelected === 1}" @click="tabSelected = 1">
                    <p>SPECS</p>
                  </div>
                  <div v-if="inTheBoxAsync" class="vue-product--tab" v-bind:class="{ 'vue-product--tab-selected': tabSelected === 2}" @click="tabSelected = 2">
                    <p>SHIPS WITH</p>
                  </div>
                  <div v-if="supplProd.length" class="vue-product--tab" v-bind:class="{ 'vue-product--tab-selected': tabSelected === 3}" @click="tabSelected = 3">
                    <p>COMPATIBLE WITH</p>
                  </div>
                  <div v-if="bundles.length" class="vue-product--tab" v-bind:class="{ 'vue-product--tab-selected': tabSelected === 4}" @click="tabSelected = 4">
                    <p>BUNDLES</p>
                  </div>
                </div>
                <accordion-container v-if="productDescription" accordion-index="0" header="DESCRIPTION" v-bind:is-selected="tabSelected === 0" v-on:change-accordion="changeAccordion">
                  <vue-description-tab
                    v-bind:product-description="productDescription"
                    v-bind:product-handle="product.handle"
                  />
                </accordion-container>
                <accordion-container v-if="specs2" accordion-index="1" header="SPECS" v-bind:is-selected="tabSelected === 1" v-on:change-accordion="changeAccordion">
                  <vue-specs-tab
                    v-bind:specs2="specs2"
                    v-bind:needs-updating="needsUpdating"
                  />
                </accordion-container>
                <accordion-container v-if="inTheBoxAsync" accordion-index="2" header="SHIPS WITH" v-bind:is-selected="tabSelected === 2" v-on:change-accordion="changeAccordion">
                  <vue-recommended-accessories
                    v-bind:accessories="inTheBoxAsync"
                    v-bind:in-the-box="true"
                  />
                </accordion-container>
                <accordion-container v-if="supplProd.length" accordion-index="3" header="COMPATIBLE WITH" v-bind:is-selected="tabSelected === 3" v-on:change-accordion="changeAccordion">
                  <vue-recommended-accessories
                    v-bind:accessories="supplProd"
                  />
                </accordion-container>
                <accordion-container v-if="bundles.length" accordion-index="4" header="BUNDLES" v-bind:is-selected="tabSelected === 4" v-on:change-accordion="changeAccordion">
                  <vue-recommended-accessories
                    v-bind:accessories="bundles"
                  />
                </accordion-container>
                <div class="vue-product--go-to-top">
                  <span class="vue-product--go-to-top-text">Go to top</span><i class="fas fa-chevron-circle-up"></i>
                </div>
              </div>`
})

vueComponents.accordionContainer = Vue.component('accordion-container', {
  props: ['header', 'accordionIndex', 'isSelected']
  ,data() {
    return {
      isOpen: false
    }
  }
  ,methods: {
    handleClick(isOpen) {
      this.isOpen = !isOpen;
      this.$emit('change-accordion', this.accordionIndex);
    }
  }
  ,delimiters: ['|', '|']
  ,template: `<div class="vue-product--accordion">
        <div class="vue-product--accordion-toggle" @click="handleClick(isOpen)">
          <p class="vue-product--accordion-title">|header|</p>
          <i class="fas fa-chevron-right cs-chevron" v-bind:class="{'cs-chevron-rotated' : isOpen}" ></i>
        </div>
        <div class="vue-product--accordion-content" v-bind:class="{ 'accordion-is-selected': isSelected, 'show-accordion-content' : isOpen, 'hide-accordion-content' : !isOpen}">
          <slot></slot>
        </div>
      </div>`
    })


vueComponents.imageGallery = Vue.component('image-gallery', {
  props: ['productImages']
  ,data() {
    return {
      clientXStart: null,
      endX: null,
      imageIndexSelected: 0,
      thumbnailOptions: {
        // slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView: 5,
        autoHeight: true,
        mousewheel: true,
        spaceBetween: 50,
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      galleryOptions: {
        // slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView: 1,
        autoHeight: true,
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        },
      }
    }
  }
  ,methods: {
    changeImage(imageIndex) {
      if (imageIndex < 0 || imageIndex > this.productImages.length-1) {
        return;
      } else {
        this.imageIndexSelected = imageIndex;
        this.gallerySwiper.slideTo(imageIndex, 300, false)
        this.thumbnailSwiper.slideTo(imageIndex, 300, false)
      }
    }
  }
  ,mounted() {
    let _this = this;
    _this.gallerySwiper.on( 'slideChange', function() {
      let index = _this.gallerySwiper.activeIndex;
      _this.thumbnailSwiper.slideTo(index, 300, false)
      _this.imageIndexSelected = index;
   });
  }
  ,computed: {
    thumbnailSwiper() {
      return this.$refs.thumbnailSwiper.swiper
    },
    gallerySwiper() {
      return this.$refs.gallerySwiper.swiper
    },
  }
  ,filters: {
    thumbnail_img(image) {
      if (["_pico", "_icon", "_thumb", "_small", "_compact", "_medium", "_large", "_grande", "_original"].some(each => image.indexOf(each) > -1)) {
        return image;
      } else if (image.indexOf(".png.jpg") > -1) {
        return image.split(".png.jpg").join("_75x.png.jpg");
      } else if (image.indexOf(".png") > -1) {
        return image.split(".png").join("_75x.png");
      } else if (image.indexOf(".jpg") > -1) {
        return image.split(".jpg").join("_75x.jpg");
      } else {
        return image;
      }
    }
  }
  ,delimiters: ['|', '|']
  ,template: `<div v-if="productImages.length > 0" class="vue-product--gallery">
    <div class="gallery-swiper">
      <swiper ref="gallerySwiper" :options="galleryOptions">
        <swiper-slide @click="changeImage(imageIndex)" @touchEnd="changeImage(imageIndex)" v-for="(image, imageIndex) in productImages" :key="imageIndex">
          <img class="vue-product--gallery-image" :src="image.node.src" data-lightbox="image-1"/>
        </swiper-slide>
      </swiper>
      <div v-if="productImages.length > 1" class="image-gallery--arrows">
        <div class="image-gallery--left-arrow" v-bind:class="{'image-gallery--arrow-disabled': this.imageIndexSelected <= 0 }" @click="changeImage(imageIndexSelected-1)">
          <img src="https://cdn.shopify.com/s/files/1/0095/4332/files/left-chevron.svg?12649"/>
        </div>
        <div class="image-gallery--right-arrow" v-bind:class="{'image-gallery--arrow-disabled': this.imageIndexSelected >= productImages.length-1 }" @click="changeImage(imageIndexSelected+1)">
          <img src="https://cdn.shopify.com/s/files/1/0095/4332/files/right-chevron.svg?12649"/>
        </div>
      </div>
    </div>
    <div class="thumbnail-swiper" v-if="productImages.length > 1">
      <swiper ref="thumbnailSwiper" :options="thumbnailOptions">
        <swiper-slide @click="changeImage(imageIndex)" @touchEnd="changeImage(imageIndex)" v-for="(image, imageIndex) in productImages" :key="imageIndex">
          <img @click="changeImage(imageIndex)" 
              class="vue-product--gallery-thumbnail" 
              v-bind:class="{ 'vue-product--gallery-thumbnail-selected': imageIndex === imageIndexSelected }"
              :src="image.node.originalSrc | thumbnail_img"></img>
        </swiper-slide>
      </swiper>
    </div>
  </div>`
  })


vueComponents.productOptions = Vue.component('product-options', {
  props: ['product', 'selectedOptions', 'variantTitles', 'changeQuantityToInput', 'quantity', 'selectedVariant', 'validVariants']
  ,delimiters: ['|', '|']
  ,methods: {
    isDisabled(optionIndex, value) {
      return optionIndex !== 0 && !this.variantTitles.includes([...this.selectedOptions.slice(0,optionIndex), value, ...this.selectedOptions.slice(optionIndex+1)].join(' / '))
    },
    isSelected(optionIndex, value) {
      return this.selectedOptions[optionIndex] === value
    },
    handleClick(valueIndex) {
    }
    
    },
  computed:{
        isPreorder: function() {
      let preorderTag = this.product.tags.find(each => each.toLowerCase().indexOf('preorder') > -1 )
    	console.log("preorderTag", preorderTag);
      if (preorderTag) {
      	return true
      } else {
      	return false
      }
    }
    
    
  
    
  }
  ,template: `<div class="vue-product--options">
    <div v-for="(option, optionIndex) in product.options" v-if="option.name !== 'Title'" :key="optionIndex" class="vue-product--option" v-bind:class="{'vue-product--option-outline' : option.values.length > 3}">
      <div class="vue-product--options-label-container">
        <label :for="selectedOptions[optionIndex]" class="vue-product--options-label">|option.name|</label>
      </div>
      <select v-if="option.values.length > 3" :id="selectedOptions[optionIndex]" :value="selectedOptions[optionIndex]" @input="$emit('change-option', optionIndex, $event.target.value)" class="vue-product--option-select">
      <option v-for="(value, valueIndex) in option.values" :key="valueIndex" :disabled="isDisabled(optionIndex, value)" v-bind:class="{ 'option-inactive': isDisabled(optionIndex, value)}">|value|</option>
      </select>
      <div v-else class="small-options-container">
        <button @click="$emit('change-option', optionIndex, value)" class="small-options-container-button" v-for="(value, valueIndex) in option.values" :key="valueIndex" v-bind:class="{ 'small-options-container-button-selected': isSelected(optionIndex, value),'small-options-container-button-clickable': !isDisabled(optionIndex, value), 'small-options-container-button-not-clickable': isDisabled(optionIndex, value) }" :disabled="isDisabled(optionIndex, value)">|value|</button>
      </div>
    </div>
    <p style="color: red;" v-if="validVariants && validVariants.length && !validVariants.includes(selectedVariant.sku)">This variant is not compatible with your compatability filters.</p>
    <add-to-cart
      v-bind:selected-variant="selectedVariant"
      v-bind:quantity="quantity"
      v-bind:product="product"
      v-bind:change-quantity-to-input="changeQuantityToInput"
      @add-to-cart="$emit('add-to-cart', ...arguments)"
      @change-quantity="$emit('change-quantity', ...arguments)">
    </add-to-cart>
	<div v-if="selectedVariant.availability" class="vue-product--stock-container">
	  <p class="vue-product--in-stock-message">|selectedVariant.availability.value|</p>
	</div>
    <a v-if="!product.tags.includes('smallhd-only')"" href="https://www.smallhd.com/resellers" class="available-at-resellers-link">
      <div class="available-at-resellers-container">
        <p class="available-at-resellers-text">AVAILABLE THROUGH OUR RESELLERS</p>
      </div>
    </a>
	<div v-if="isPreorder || !selectedVariant.availableForSale">
<div style="margin-top:15px; text-align:center;">
						<div v-if="!selectedVariant.availableForSale">
<div style="font-weight:bold;color:black;font-size:16px;">Sign up to learn when it's available:</div>
						</div>
						<div v-else-if="isPreorder">
                          <!--div style="font-weight:bold;color:#9a9a9a;">Not ready to pre-order?</div-->
                          <div>Sign up to learn more:</div>
						</div>
					<form method="POST" style="display:flex;justify-content:center;margin-top:0;line-height:normal; padding-top:10px;" 
							action="https://cs-inc.activehosted.com/proc.php" id="_form_24_" class="_form _form_24 _inline-form  _dark" novalidate>
                          <input type="hidden" name="u" value="24" />
                          <input type="hidden" name="f" value="24" />
                          <input type="hidden" name="s" />
                          <input type="hidden" name="c" value="0" />
                          <input type="hidden" name="m" value="0" />
                          <input type="hidden" name="act" value="sub" />
                          <input type="hidden" name="v" value="2" />
                          <div class="_form-content">
                            <div class="_form_element _x27226589 _full_width " >
                              <div class="_field-wrapper">
<input type="text" style="font-size:12px; padding:3px;min-width:200px;" name="email" placeholder="Enter your email" required/>
                              </div>
                            </div>
                              <input data-autofill="false" type="hidden" name="field[152][]" value="~|">
                              <input data-autofill="false" type="hidden" name="field[152][]" v-bind:value="selectedVariant.sku">
                            <div class="_button-wrapper _full_width">
                              <button id="_form_24_submit" class="_submit" type="submit">
                                Submit
                              </button>
                            </div>
                            <div class="_clear-element">
                            </div>
                          </div>
                          <div class="_form-thank-you" style="display:none;">
                          </div>
                        </form>
						</div>
					</div>
                  </div>

  </div>`
})

vueComponents.addToCart = Vue.component('add-to-cart', {
  props: ['product', 'changeQuantityToInput', 'quantity', 'selectedVariant']
  ,delimiters: ["~~", "~~"]
  ,computed: {
    isPreorder: function() {
      console.log(this.selectedVariant);
      let preorderTag = this.product.tags.find(each => each.toLowerCase().indexOf('preorder') > -1 )
    	console.log("preorderTag", preorderTag);
      if (preorderTag) {
      	return true
      } else {
      	return false
      }
    }
    ,showAffirm: function(){
      return !(this.product.tags.some(el=>{return el == 'hide-affirm';})) && parseFloat(this.selectedVariant.price) >= 250;
    }
  }
  ,watch:{
    selectedVariant:function(newVariant, oldVariant){
       if (affirm) {
         $('#affirm-product-message').attr('data-amount',newVariant.price*100);
         affirm.ui.refresh();
       }
    }
  }
  ,template: `<div v-if="!product.tags.includes('resellers-only')" class="vue-product--quantity-and-cart-button">
				<div v-if="isPreorder && selectedVariant.retail_price && selectedVariant.preorder_deposit" style="margin: auto;">
                  <p v-if="selectedVariant.retail_price" class="vue-product--price">
                      <span style="color: black; font-size: 20px;">Price: </span>
                      <span class="currency-symbol">$</span>
                      <span class="price" v-text="selectedVariant.retail_price.value"></span>
                      <!--span class="currency-text">USD only</span-->
                  </p>
                  <p v-if="selectedVariant.preorder_deposit" class="vue-product--price">
                      <span style="color: black; font-size: 20px;">Deposit: </span>
                      <span class="currency-symbol">$</span>
                      <span class="price" v-text="selectedVariant.preorder_deposit.value"></span>
                      
                  </p>
				</div>
                <div v-else style="margin: auto;">
                  <p v-if="selectedVariant.compareAtPrice && selectedVariant.price !== selectedVariant.compareAtPrice" class="vue-product--price vue-product--compare-price">
                      <span class="currency-symbol">$</span>
					  <span class="price">~~selectedVariant.compareAtPrice | money~~</span>
                      <!--span class="currency-text">USD only</span-->
                  </p>
				<div v-if="product.tags.includes('introductory-price')" class="introdutory-price">
					Limited-Time Introductory Price
				</div>
                  <div class="vue-product--price">
                      <span class="currency-symbol">$</span>
                      <span class="price">~~selectedVariant.price | money ~~</span>
                      <!--span class="currency-text">USD only</span-->
                  </div>
                </div>
				<p id="affirm-product-message" class="affirm-as-low-as" v-show="showAffirm" data-page-type="product" :data-amount="selectedVariant.price*100"></p>
                <div class="vue-product--quantity-and-add-to-cart">
                  <div class="vue-product--quantity">
                    <p class="cs-text-3 add-to-cart-quantity-label">QTY:</p>
                    <div class="vue-product--quantity-toggle">
                      <p class="vue-product--quantity--remove-one" @click="$emit('change-quantity', -1)" >-</p>
                      <p class="vue-product--quantity--value">~~quantity~~</p>
                      <p class="vue-product--quantity--add-one" @click="$emit('change-quantity', 1)">+</p>
                    </div>
                  </div>
                  <div class="vue-product--add-to-cart-content">
                    <button :disabled="!selectedVariant.availableForSale" @click="$emit('add-to-cart', product.id, selectedVariant, isPreorder)" class="vue-product--cart-button" >
                      <p class="vue-product--cart-button--top add-to-cart-button" v-bind:class="{'vue-product--cart-button--top--disabled' : !selectedVariant.availableForSale}" :data-product-id="product.id" :data-variant-id="selectedVariant.id">
                        <span v-if="!selectedVariant.availableForSale">Not Yet Available</span>
                        <span v-else-if="isPreorder && selectedVariant.preorder_shipdate" v-text="'Preorder - ships '+selectedVariant.preorder_shipdate.value"></span>
                        <span v-else-if="isPreorder">Pre-Order</span>
                        <span v-else>Add to cart</span>
                      </p>
                    </button>
					</div>
                </div>
              </div>`
})  

